import React from 'react';
import { Link } from 'react-router-dom';
import { AuthBrandMark } from '../../common/layout/AuthLayout';

/**
 * Shell for the public (no-auth) pages — support and privacy policy, required for App Store
 * compliance. Slim brand bar on a neutral background and a centered, readable content card.
 */
export default function PublicPage({ children, footer, width = 'max-w-3xl' }) {
    return (
        <div className="min-h-screen bg-surface-50">
            <header className="border-b border-surface-200 bg-white">
                <div className={`mx-auto flex h-16 items-center justify-between px-4 sm:px-6 ${width}`}>
                    <div className="flex items-center gap-2.5">
                        <AuthBrandMark />
                        <span className="text-base font-semibold tracking-tight text-surface-900">Shelf</span>
                    </div>
                    <nav className="flex items-center gap-1 text-sm">
                        <Link to="/support" className="rounded-md px-2.5 py-1.5 font-medium text-surface-600 hover:bg-surface-100 hover:text-surface-900">
                            Soporte
                        </Link>
                        <Link to="/privacy-policy" className="rounded-md px-2.5 py-1.5 font-medium text-surface-600 hover:bg-surface-100 hover:text-surface-900">
                            Privacidad
                        </Link>
                    </nav>
                </div>
            </header>

            <main className={`mx-auto px-4 py-8 sm:px-6 sm:py-12 ${width}`}>
                <article className="shelf-card p-6 sm:p-10">{children}</article>
                {footer && <footer className="mt-6 text-center text-sm text-surface-500">{footer}</footer>}
            </main>
        </div>
    );
}
